import PlanAndPricingStore from "containers/PlanAndPricing/PlanAndPricingStore";
import SentimentTrackerPaymentContainer from "./SentimentTrackerPaymentContainer";

export default PlanAndPricingStore(SentimentTrackerPaymentContainer);